import React from "react";
import PropTypes from "prop-types";
import SFIconButton from "../../../button/iconButton";
import { SFCopilotIcon } from "../../../icons";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const SFIconButtonStyled = styled(SFIconButton, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active }) => ({
  backgroundColor: theme.palette.grey100.main,
  borderRadius: "20px",
  height: "28px",
  padding: "2px",
  width: "28px",
  "& .MuiSvgIcon-root": {
    height: "20px",
    width: "20px",
  },
  ...(active && {
    backgroundColor: theme.palette.blue500.main,
    "& .MuiSvgIcon-root": {
      color: theme.palette.white.main,
    },
  }),
  // Change the color of the background and the icon when hovered
  "&:hover": {
    backgroundColor: theme.palette.blue500.main,
    "& .MuiSvgIcon-root": {
      color: theme.palette.white.main,
    },
  },
}));

const CopilotAction = ({ onClick, disabled, active }) => {
  return (
    <SFIconButtonStyled onClick={onClick} disabled={disabled} active={active}>
      <SFCopilotIcon color={!disabled ? "blue500" : "grey350"} />
    </SFIconButtonStyled>
  );
};

export default CopilotAction;

CopilotAction.propTypes = {
  // The function to call when the copilot action is clicked
  onClick: PropTypes.func.isRequired,
};
